<component :is="tag" :to="link" class="breadcrumb-item text-ellipsis" :title="item.label">{{item.label}}</component>
